import { useState, useEffect } from "react";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { TextField, Box, Button, Typography } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import config from "../../../../utils/config";


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


const validerHeures = (disponibilites) => {
  for (const jour in disponibilites) {
    const { heureDebut, heureFin } = disponibilites[jour];
    if (!heureDebut || !heureFin) {
      return false;
    }
  }
  return true;
};


const validerMatieres = (matieres) => {
  for (const matiere in matieres) {
    if (matieres[matiere].length === 0) {
      return false;
    }
  }
  return true;
};

const classesGeneralesPrimaire = [
  'CP1',
  'CP2',
  'CE1',
  'CE2',
  'CM1',
  'CM2'
];

const classesGeneralesCollege = [
  '6eme',
  '5eme',
  '4eme',
  '3eme',
];


const classesGeneralesLyceeA = [
  'Seconde A',
  'Première A',
  'Terminale A'
];
const classesGeneralesLyceeD = [
  'Seconde D',
  'Première D',
  'Terminale D',
];
const classesGeneralesLyceeC = [
  'Seconde C',
  'Première C',
  'Terminale C',
];

const matieresGeneralesPrimaire = [
  'Mathematiques',
  'Francais',
  'Question de cours'
];

const matieresGeneralesCollege = [
  'Mathematiques',
  'Anglais',
  'Francais',
  'Physique-Chimie',
  'Svt'
];

const matieresGeneralesLyceeA = [
  'Mathematiques',
  'Anglais',
  'Francais',
  'Philosophie'
];

const matieresGeneralesLyceeDC = [
  'Mathematiques',
  'Anglais',
  'Francais',
  'Philosophie',
  'Physique-Chimie',
  'Svt'
];



const jours = [
  'Lundi',
  'Mardi',
  'Mercredi',
  'Jeudi',
  'Vendredi',
  'Samedi',
  'Dimanche',
];

const parseClassesFromProps = (str) => (str || '').split(',').filter(Boolean);
const parseJoursFromProps = (str) => (str || '').split(',').filter(Boolean);
const parseJsonFromProps = (str) => {
  if (!str || typeof str !== 'string') return {};
  try {
    const parsed = JSON.parse(str);
    return typeof parsed === 'object' && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
};

const Step3 = (props) => {
  const [classeGeneraleName, setClasseGeneraleName] = useState(() => parseClassesFromProps(props.classesGeneralesEnseignables));
  const [joursName, setJoursName] = useState(() => parseJoursFromProps(props.joursDisponibles));
  const [disponibilites, setDisponibilites] = useState(() => parseJsonFromProps(props.periodeJournee));

  const [matieres, setMatieres] = useState(() => parseJsonFromProps(props.matieresGeneralesEnseignables));
  const [heureSaisie, setHeureSaisie] = useState(false);
  const [matiereSaisie, setMatiereSaisie] = useState(false);

  const handleChange = (e, jour) => {
    const { name, value } = e.target;

    if(value !== ""){

    let updatedValue = value; // Utilisez une variable let pour la valeur
    // Validation de l'heure de début
    if (name === "heureDebut") {
      const heureDebut = value.slice(0, 2);
      const minuteDebut = value.slice(3, 5);
      const heureFin = disponibilites[jour]?.heureFin?.slice(0, 2) || "";
      const minuteFin = disponibilites[jour]?.heureFin?.slice(3, 5) || "";
      if (heureDebut < "07" || heureDebut > "18") {
        // L'heure de début est inférieure à 7h, ajustement à 7h
        updatedValue = "07" + value.slice(2);
      } else if (heureFin && heureDebut > heureFin) {
        let h = Number(heureFin) - 2
        if((h+"").length === 1){
          h = "0"+h          
        }
        updatedValue = h + value.slice(2);
      }else if (heureDebut === heureFin){
        setHeureSaisie(false)
        
        let h = Number(heureDebut) - 2
        if((h+"").length === 1){
          h = "0"+h          
        }
        updatedValue = h +":"+minuteDebut;
        if (minuteDebut > minuteFin){
          updatedValue = heureDebut+":"+minuteFin 
        }
      }else{
        if(heureFin !== "" && minuteFin !== ""){
          const diffHours = heureFin - heureDebut;
          
          if(diffHours === 2){
            disponibilites[jour].heureFin = heureFin+":"+minuteDebut
          }

          if (diffHours < 2) {
            // L'écart entre l'heure de début et l'heure de fin est inférieur à 2 heures
            let h = Number(heureFin) - 2
            if((h+"").length === 1){
              h = "0"+h          
            }
            updatedValue = h +":"+minuteFin;
            // Tu peux également afficher un message d'erreur approprié
            // setError("L'écart entre l'heure de début et l'heure de fin doit être d'au moins 2 heures.");
          }
        }
      }


    }
    

    // Validation de l'heure de fin
    if (name === "heureFin") {
      const heureFin = value.slice(0, 2);
      const minuteFin = value.slice(3, 5);
      const heureDebut = disponibilites[jour]?.heureDebut?.slice(0, 2) || "";
      const minuteDebut = disponibilites[jour]?.heureDebut?.slice(3, 5) || "";

      if (heureFin > "18" || heureFin < "07") {
        // L'heure de fin est supérieure à 18h, ajustement à 18h
        updatedValue = "18" + value.slice(2);
      } else if (heureDebut && heureFin < heureDebut) {
        // L'heure de fin est inférieure à l'heure de début, ajustement à l'heure de début actuelle
        updatedValue = heureDebut + value.slice(2);
      }else if (heureDebut === heureFin){
        let h = Number(heureFin) + 2
        if((h+"").length === 1){
          h = "0"+h          
        }
        updatedValue = h + value.slice(2);
        if (minuteFin < minuteDebut){
          updatedValue = heureFin+":"+minuteDebut 
        }
      }else{
        if(heureDebut !== "" && minuteDebut !== ""){
          const diffHours = heureFin - heureDebut;
          if (diffHours < 2) {
            // L'écart entre l'heure de début et l'heure de fin est inférieur à 2 heures
            let h = Number(heureFin) + 1
            if((h+"").length === 1){
              h = "0"+h          
            }
            updatedValue = h + value.slice(2);
            // Tu peux également afficher un message d'erreur approprié
            // setError("L'écart entre l'heure de début et l'heure de fin doit être d'au moins 2 heures.");
          }
        }
      }
    }

    setDisponibilites((prevState) => ({
      ...prevState,
      [jour]: {
        ...prevState[jour],
        [name]: updatedValue,
      },
    }));

    const updatedHeureSaisie = validerHeures(disponibilites);
    setHeureSaisie(updatedHeureSaisie);

  }
  
  };

  
  useEffect(() => {
    const updatedHeureSaisie = validerHeures(disponibilites);
    setHeureSaisie(updatedHeureSaisie);
  }, [disponibilites])

  const {
    ville,
    quartiersAccessibles,
    setQuartiersAccessibles,
    typePieceIdentite,
    setTypePieceIdentite,
    pieceIdentite,
    setPieceIdentite,
    joursDisponibles,
    setJoursDisponibles,
    classesGeneralesEnseignables,
    setClassesGeneralesEnseignables,
    matieresGeneralesEnseignables,
    setMatieresGeneralesEnseignables,
    periodeJournee,
    setPeriodeJournee,
    setShowBtn,
    setError,
  } = props;


  const [classeDeleted , setClasseDeleted] = useState([])
  const [classeChecked , setClasseChecked] = useState(() => parseClassesFromProps(props.classesGeneralesEnseignables))

  const [msgJoursDisponibles, setMsgJoursDisponibles] = useState("");
  const [msgHeuresSaisies, setMsgHeuresSaisies] = useState("");
  const [msgMatieresSaisies, setMsgMatieresSaisies] = useState("");

  const [msgClassesGeneralesEnseignables, setMsgClassesGeneralesEnseignables] =
    useState("");

  const handleChangeClassesGenerales = (event) => {
    const {
      target: { value },
    } = event;
    setClasseGeneraleName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
    
    setClasseChecked(value)

    const classesC = classesGeneralesPrimaire.filter((element) => !event.target.value.includes(element));
    setClasseDeleted(classesC)
    

    if(matieres.hasOwnProperty(value[value.length-1])){
      setMatiereSaisie(validerMatieres(matieres))
    }else{
      setMatiereSaisie(false)
    }
    
  };

  useEffect(() => {
    classeDeleted.forEach(classe => {
      delete matieres[classe]
      setMatieres(matieres)
    }) 
  }, [classeDeleted,matieres])

  useEffect(() => {
    classeChecked.forEach(classe => {
      if(matieres.hasOwnProperty(classe)){
        setMatiereSaisie(validerMatieres(matieres))
      }else{
        setMatiereSaisie(false)
      }
    }) 
  }, [classeChecked,matieres])


  useEffect(() => {
    classeChecked.forEach(classe => {
      if(matieres.hasOwnProperty(classe)){
        setMatiereSaisie(validerMatieres(matieres))
      }else{
        setMatiereSaisie(false)
      }
    }) 

  }, [matieres,classeChecked])

  const handleChangeMatieres = (e, classe) => {
    const { value } = e.target;
  
    // Vérifier si la classe appartient aux différentes catégories
    if (classesGeneralesCollege.includes(classe)) {
      // Si la classe est dans les collèges, limiter à 3 matières maximum
      if (value.length <= 3) {
        setMatieres((prevState) => ({
          ...prevState,
          [classe]: value,
        }));
      } else {
        alert('Vous ne pouvez sélectionner que 3 matières maximum pour le collège');
      }
    } else if (classesGeneralesPrimaire.includes(classe)) {
      // Si la classe est dans les primaires, forcer la sélection de 3 matières
      // Par défaut, sélectionne toutes les matières et empêche la désélection d'une seule
      if (value.length !== 3) {
        setMatieres((prevState) => ({
          ...prevState,
          [classe]: matieresGeneralesPrimaire, // Remplacez ici par les matières par défaut
        }));
      } else {
        setMatieres((prevState) => ({
          ...prevState,
          [classe]: value,
        }));
      }
    } else if (
      classesGeneralesLyceeA.includes(classe) ||
      classesGeneralesLyceeD.includes(classe) ||
      classesGeneralesLyceeC.includes(classe)
    ) {
      // Si la classe est dans les lycées, limiter à 2 matières maximum
      if (value.length <= 2) {
        setMatieres((prevState) => ({
          ...prevState,
          [classe]: value,
        }));
      } else {
        alert('Vous ne pouvez sélectionner que 2 matières maximum pour le lycée');
      }
    } else {
      // Pour toutes les autres classes, appliquer une limite par défaut
      setMatieres((prevState) => ({
        ...prevState,
        [classe]: value,
      }));
    }
  };
  
  
  

  const handleChangeJours = (e) => {

    const {
      target: { value },
    } = e;
    setJoursName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );

    const selectedDays = e.target.value;
    const updatedDisponibilites = {};
    selectedDays.forEach((day) => {
      if (!disponibilites[day]) {
        updatedDisponibilites[day] = {
          heureDebut: "",
          heureFin: "",
        };
      } else {
        updatedDisponibilites[day] = disponibilites[day];
      }
    });
    setDisponibilites(updatedDisponibilites);
  };

  useEffect(() => {
    const quartiersOk = quartiersAccessibles && quartiersAccessibles.length > 0;
    const docsOk = typePieceIdentite && pieceIdentite;
    if (
      quartiersOk &&
      docsOk &&
      joursDisponibles !== "" &&
      classesGeneralesEnseignables !== "" &&
      matieresGeneralesEnseignables !== "" &&
      periodeJournee !== "" &&
      heureSaisie && matiereSaisie
    ) {
      setShowBtn(true);
    } else {
      setShowBtn(false);
    }
    // eslint-disable-next-line
  }, [
    quartiersAccessibles,
    typePieceIdentite,
    pieceIdentite,
    joursDisponibles,
    classesGeneralesEnseignables,
    matieresGeneralesEnseignables,
    periodeJournee,
    heureSaisie,
    matiereSaisie
  ]);

  useEffect(() => {
    if (joursName.length === 0) {
      setMsgJoursDisponibles("Les jours disponibles sont obligatoires");
    }else if (joursName.length < 2) {
      setMsgJoursDisponibles("Veuillez disposer d'au moins deux jours de disponibles");
    }
    else {
      setMsgJoursDisponibles("");
    }
    setJoursDisponibles(joursName.join(","))
  }, [joursName,setJoursDisponibles]);

  useEffect(() => {
    if(heureSaisie){
      setMsgHeuresSaisies("")
      setPeriodeJournee(JSON.stringify(disponibilites));
    }else{
      if(joursName.length >= 2){
        setMsgHeuresSaisies("Veuillez saisir toutes les heures où vous êtes disponibles")
      }
    }
  }, [heureSaisie,disponibilites,setPeriodeJournee, joursName])

  useEffect(() => {
    if(matiereSaisie){
      setMsgMatieresSaisies("")
      setMatieresGeneralesEnseignables(JSON.stringify(matieres))
    }else{
      setMsgMatieresSaisies("Veuillez saisir toutes les matieres")
    }
  }, [matiereSaisie,matieres,setMatieresGeneralesEnseignables])


  useEffect(() => {
    if (
      classeGeneraleName.length === 0
    ) {
      setMsgClassesGeneralesEnseignables(
        "Les classes generales sont obligatoires"
      );
      setMatiereSaisie(true)
    } else {
      setMsgClassesGeneralesEnseignables("");
    }
    setClassesGeneralesEnseignables(classeGeneraleName.join(","))
  }, [classeGeneraleName,setClassesGeneralesEnseignables]);

  

  useEffect(() => {
    setMsgJoursDisponibles("");
    setMsgClassesGeneralesEnseignables("");
    setMsgHeuresSaisies("");
    setMsgMatieresSaisies("");
    setShowBtn(false);  
    setError("");
    // eslint-disable-next-line
  }, []);

  const [quartiersStructure, setQuartiersStructure] = useState(null);
  useEffect(() => {
    const v = (ville || '').trim();
    if (!v) {
      setQuartiersStructure(null);
      return;
    }
    const url = `${config.apiUrl}/comptes/quartiers/structure/?ville=${encodeURIComponent(v)}`;
    fetch(url)
      .then((r) => r.json())
      .then((data) => setQuartiersStructure(data?.structure || null))
      .catch(() => setQuartiersStructure(null));
  }, [ville]);

  // Quand la ville change, on réinitialise la sélection des quartiers
  // pour éviter d'afficher des quartiers d'une ancienne ville (ex: Kintélé).
  useEffect(() => {
    setQuartiersAccessibles([]);
    setTempQuartiersAccessibles([]);
    setOpenQuartiersModal(false);
    // eslint-disable-next-line
  }, [ville]);

  const [openQuartiersModal, setOpenQuartiersModal] = useState(false);
  const [tempQuartiersAccessibles, setTempQuartiersAccessibles] = useState([]);

  const toggleQuartierTemp = (q) => {
    setTempQuartiersAccessibles((prev) => {
      const current = Array.isArray(prev) ? prev : [];
      return current.includes(q) ? current.filter((x) => x !== q) : [...current, q];
    });
  };

  const handleOpenQuartiersModal = () => {
    setTempQuartiersAccessibles(Array.isArray(quartiersAccessibles) ? quartiersAccessibles : []);
    setOpenQuartiersModal(true);
  };

  const handleCancelQuartiersModal = () => {
    setOpenQuartiersModal(false);
  };

  const handleValidateQuartiersModal = () => {
    setQuartiersAccessibles(Array.isArray(tempQuartiersAccessibles) ? tempQuartiersAccessibles : []);
    setOpenQuartiersModal(false);
  };

  const selectedSet = new Set(Array.isArray(quartiersAccessibles) ? quartiersAccessibles : []);
  const selectedSummary = (quartiersStructure?.villes || [])
    .map((city) => {
      const arrs = (city.arrondissements || [])
        .map((a) => {
          const qs = (a.quartiers || []).filter((q) => selectedSet.has(q));
          if (!qs.length) return null;
          return { arrondissement: a.arrondissement, quartiers: qs };
        })
        .filter(Boolean);

      if (!arrs.length) return null;
      return { ville: city.ville, arrondissements: arrs };
    })
    .filter(Boolean);

  return (
    <div className="text-center mt-4">
      <FormControl sx={{ width: '100%', mb: 2 }} variant="outlined" disabled={!ville}>
        <p style={{ marginBottom: 6, fontWeight: 500 }}>
          Quartiers proches de vous où vous pouvez encadrer
        </p>

        {quartiersStructure?.departement && (
          <p style={{ margin: "0 0 10px", color: "text.secondary" }}>
            Département : <b>{quartiersStructure.departement}</b>
          </p>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Button
            variant="outlined"
            onClick={handleOpenQuartiersModal}
            disabled={!ville}
          >
            {(quartiersAccessibles || []).length > 0 ? "Modifier les quartiers" : "Choisir les quartiers"}
          </Button>
        </Box>

        {(quartiersAccessibles || []).length > 0 ? (
          <Box sx={{ textAlign: 'left', px: 1 }}>
            {selectedSummary.map((city) => (
              <Box key={city.ville} sx={{ mb: 2 }}>
                <Typography sx={{ fontWeight: 700 }}>{`Ville : ${city.ville}`}</Typography>
                {city.arrondissements.map((a) => (
                  <Box key={`${city.ville}|${a.arrondissement}`} sx={{ ml: 2, mt: 1 }}>
                    <Typography sx={{ fontWeight: 600 }}>{a.arrondissement}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {a.quartiers.join(', ')}
                    </Typography>
                  </Box>
                ))}
              </Box>
            ))}
          </Box>
        ) : (
          <p style={{ color: 'red' }}>Aucun quartier sélectionné</p>
        )}
      </FormControl>

      <Dialog
        open={openQuartiersModal}
        onClose={handleCancelQuartiersModal}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Choisir vos quartiers</DialogTitle>
        <DialogContent dividers>
          {quartiersStructure?.departement && (
            <p style={{ margin: "0 0 10px", color: "text.secondary" }}>
              Département : <b>{quartiersStructure.departement}</b>
            </p>
          )}

          {(quartiersStructure?.villes || []).map((city) => (
            <Box key={city.ville} sx={{ mb: 2 }}>
              <Typography sx={{ fontWeight: 700, mt: 1 }}>{`Ville : ${city.ville}`}</Typography>
              {(city.arrondissements || []).map((a) => (
                <Box key={`${city.ville}|${a.arrondissement}`} sx={{ mb: 2 }}>
                  <Typography sx={{ fontWeight: 600, mt: 1 }}>{a.arrondissement}</Typography>
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                    {(a.quartiers || []).map((q) => {
                      const isChecked = tempQuartiersAccessibles.includes(q);
                      return (
                        <label
                          key={`${city.ville}|${a.arrondissement}|${q}`}
                          style={{ display: "flex", alignItems: "center", gap: 6 }}
                        >
                          <Checkbox
                            checked={isChecked}
                            onChange={() => toggleQuartierTemp(q)}
                          />
                          <span>{q}</span>
                        </label>
                      );
                    })}
                  </Box>
                </Box>
              ))}
            </Box>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelQuartiersModal}>Annuler</Button>
          <Button variant="contained" onClick={handleValidateQuartiersModal}>
            Valider
          </Button>
        </DialogActions>
      </Dialog>

        <FormControl sx={{ width: '100%', mb: 2 }}>
          <InputLabel>Type de pièce d'identité</InputLabel>
          <Select
            value={typePieceIdentite}
            label="Type de pièce d'identité"
            onChange={(e) => setTypePieceIdentite(e.target.value)}
          >
            <MenuItem value="CNI">CNI</MenuItem>
            <MenuItem value="Passeport">Passeport</MenuItem>
            <MenuItem value="NIU">NIU</MenuItem>
          </Select>
        </FormControl>

        <p style={{ marginBottom: 4, fontWeight: 500 }}>Téléversement de la pièce d'identité (obligatoire)</p>
        <Box
          component="label"
          sx={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            py: 2.5, px: 2, mb: 2,
            border: '2px dashed', borderColor: pieceIdentite ? 'success.main' : 'divider', borderRadius: 2,
            bgcolor: pieceIdentite ? 'action.selected' : 'action.hover', cursor: 'pointer',
            transition: 'border-color 0.2s, background-color 0.2s',
            '&:hover': { borderColor: 'primary.main', bgcolor: 'action.hover' },
          }}
        >
          <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={(e) => setPieceIdentite(e.target.files?.[0] || null)} style={{ display: 'none' }} />
          <CloudUploadIcon sx={{ fontSize: 36, color: 'text.secondary', mb: 0.5 }} />
          <span style={{ color: 'text.secondary', fontSize: '0.875rem' }}>
            {pieceIdentite ? pieceIdentite.name : 'Cliquez ou glissez un fichier (PDF, JPG, PNG)'}
          </span>
        </Box>

        <FormControl sx={{ width: '100%' }}>
          <InputLabel id="demo-multiple-checkbox-label"> Classes que vous pouvez enseigner</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={classeGeneraleName}
            onChange={handleChangeClassesGenerales}
            input={<OutlinedInput label="Classes que vous pouvez enseigner" />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
          >
            <h6 style={{textAlign: 'center'}}>Primaire</h6>
            {classesGeneralesPrimaire.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={classeGeneraleName.indexOf(name) > -1} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
            <h6 style={{textAlign: 'center'}}>Collège</h6>
            {classesGeneralesCollege.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={classeGeneraleName.indexOf(name) > -1} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
            <h6 style={{textAlign: 'center'}}>Lycée série A</h6>
            {classesGeneralesLyceeA.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={classeGeneraleName.indexOf(name) > -1} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
            <h6 style={{textAlign: 'center'}}>Lycée série D</h6>
            {classesGeneralesLyceeD.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={classeGeneraleName.indexOf(name) > -1} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
            <h6 style={{textAlign: 'center'}}>Lycée série C</h6>
            {classesGeneralesLyceeC.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={classeGeneraleName.indexOf(name) > -1} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <p style={{ color: "red" }}>{msgClassesGeneralesEnseignables}</p>

        {classeGeneraleName.map((classe) => {
          const matieresClasse = matieres[classe] || [];
          const labelIdMatieres = `matieres-${classe}-label`;
          return (
            <div key={classe}>
              <FormControl sx={{ width: '100%' }}>
                <InputLabel id={labelIdMatieres}>{`Matieres pour ${classe}`} que vous pouvez enseigner</InputLabel>
                <Select
                  labelId={labelIdMatieres}
                  id={`${classe}-matieres`}
                  value={matieresClasse}
                  input={<OutlinedInput label={`Matieres pour ${classe} que vous pouvez enseigner`} />}
                  onChange={(e) => handleChangeMatieres(e, classe)}
                  multiple
                  renderValue={(selected) => selected.join(', ')}
                  MenuProps={MenuProps}
                  sx={{ marginBottom: 2 }}
                >
                  {classesGeneralesPrimaire.includes(classe) && matieresGeneralesPrimaire.map(matiere => (
                    <MenuItem key={matiere} value={matiere}>
                      <Checkbox checked={matieresClasse.indexOf(matiere) > -1} />
                      <ListItemText primary={matiere} />
                    </MenuItem>
                  ))}
                  {classesGeneralesCollege.includes(classe) && matieresGeneralesCollege.map(matiere => (
                    <MenuItem key={matiere} value={matiere}>
                      <Checkbox checked={matieresClasse.indexOf(matiere) > -1} />
                      <ListItemText primary={matiere} />
                    </MenuItem>
                  ))}
                  {classesGeneralesLyceeA.includes(classe) && matieresGeneralesLyceeA.map(matiere => (
                    <MenuItem key={matiere} value={matiere}>
                      <Checkbox checked={matieresClasse.indexOf(matiere) > -1} />
                      <ListItemText primary={matiere} />
                    </MenuItem>
                  ))}
                  {classesGeneralesLyceeD.includes(classe) && matieresGeneralesLyceeDC.map(matiere => (
                    <MenuItem key={matiere} value={matiere}>
                      <Checkbox checked={matieresClasse.indexOf(matiere) > -1} />
                      <ListItemText primary={matiere} />
                    </MenuItem>
                  ))}
                  {classesGeneralesLyceeC.includes(classe) && matieresGeneralesLyceeDC.map(matiere => (
                    <MenuItem key={matiere} value={matiere}>
                      <Checkbox checked={matieresClasse.indexOf(matiere) > -1} />
                      <ListItemText primary={matiere} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          );
        })}

        <p style={{ color: "red" }}>{msgMatieresSaisies}</p>
  
      <FormControl sx={{ width: '100%' }}>
          <InputLabel id="demo-multiple-checkbox-label">Jours disponibles</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={joursName}
            onChange={handleChangeJours}
            input={<OutlinedInput label="Jours disponibles" />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
          >
            {jours.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={joursName.indexOf(name) > -1} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
          
      </FormControl>
      <p style={{ color: "red",textAlign: 'center' }}>{msgJoursDisponibles}</p>
      <p>{joursName.length < 2 ? "":"Vos heures de disponibilité pour chaque jour disponible (heure début et fin), l'heure de travail est comprise entre 07h et 18h"}</p>
      <p style={{fontWeight: 'bold'}}>        
        {joursName.length < 2 ? "":"l'écart entre vos heures dispos doit être au minimum de 2h"}
      </p>
      { joursName.length >=2 && Object.keys(disponibilites).map((jour) => (
        <div key={jour}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
          
          <TextField
            type="time"
            label={`Heure de début (${jour})`}
            id={`${jour}-heureDebut`}
            name="heureDebut"
            value={disponibilites[jour].heureDebut || ""}
            onChange={(e) => handleChange(e, jour)}
            sx={{ m: 1, width: `calc(100% - ${(10 + 14 * jour.length)}px)` }}
          />
          <TextField
            type="time"
            id={`${jour}-heureFin`}
            label={`Heure de fin (${jour})`}
            name="heureFin"
            value={disponibilites[jour].heureFin || ""}
            onChange={(e) => handleChange(e, jour)}
            sx={{ m: 1, width: `calc(100% - ${(10 + 14 * jour.length)}px)` }}
          />
        </Box>
        </div>
      ))}
      <p style={{ color: "red",textAlign: 'center' }}>{msgHeuresSaisies}</p>
    </div>
  );
};

export default Step3;
